import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { ISubAdminPayload } from "../../../types/api/subAdmin";

export async function detailSubAdmin(
  _id: string
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> {
  return axios.get(`${API_ENDPOINTS.SUB_ADMINS_DETAILS}/${_id}`);
}

export async function listSubAdmins(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<ISubAdminPayload[]>>> {
  return axios.get(API_ENDPOINTS.SUB_ADMINS_LIST, {
    params: qData,
  });
}

export async function createSubAdmins(
  payload: ISubAdminPayload
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> {
  return axios.post(API_ENDPOINTS.SUB_ADMINS_CREATE, payload);
}

export async function updateSubAdmins(
  payload: ISubAdminPayload
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> {
  return axios.put(`${API_ENDPOINTS.SUB_ADMINS_UPDATE}/${payload?._id}`, payload);
}
